export enum ShareOnSmType {
  facebook = 'facebook',
  twitter = 'twitter',
  linkedIn = 'linkedIn',
  email = 'email',
}
